import React from "react";
import { useDispatch } from "react-redux";
import {
  setShowRuler,
  setShowCrossHair,
} from "../../../redux/actions/PsrCameraLiveImageAction";
import { useTypedSelector } from "../../../redux/reducers/RootReducer";
import {
  getShowCrossHair,
  getShowRuler,
} from "./../../../redux/reducers/PsrCameraLiveImageReducer";
import SwitchButton from "./../../Buttons/SwitchButton";
import "./../../Imager/LiveImagePreferences.css";
import {
  getModuleStateById,
  getModuleState,
} from "../../../redux/reducers/ModuleStateReducer";
import PsrCameraApi from "../../../api/PsrCameraApi";

export type Props = {
  psrIdentifier: string;
  psrCameraId: number;
};

export default function PsrCameraLiveImagePreferences({
  psrIdentifier,
  psrCameraId,
}: Props) {
  const dispatch = useDispatch();
  const ruler = useTypedSelector((state) => getShowRuler(state));
  const crosshair = useTypedSelector((state) => getShowCrossHair(state));

  const psrState = useTypedSelector((state) =>
    getModuleState(state, psrIdentifier)
  ).psr;

  const psrCameraState = psrState?.psrCameras.find(
    (x) => x.psrCameraId === psrCameraId
  );

  if (psrState == null) {
    throw new Error("Psr state is null");
  }

  if (psrCameraState == null) {
    throw new Error("Psr Camera state is null");
  }

  const onToggleScaleBar = () => {
    dispatch(setShowRuler(!ruler));
  };
  const onToggleCrosshair = () => {
    dispatch(setShowCrossHair(!crosshair));
  };

  return (
    <div className="live-image-pref">
      {/* <div className="live-image-pref-row">
        <span>Enable Scale Bar:</span>
        <SwitchButton isOn={ruler} onToggle={() => onToggleScaleBar()} withLetter={false} />
      </div> */}
      <div className="live-image-pref-row">
        <span>Enable Crosshair Guide:</span>
        <SwitchButton
          isOn={crosshair}
          onToggle={() => onToggleCrosshair()}
          withLetter={false}
        />
      </div>
      <div className="live-image-pref-row">
        <span>Enable Fiducial Marker Detection:</span>
        <SwitchButton
          isOn={psrCameraState.isDetectingFiducialMarker}
          onToggle={() =>
            PsrCameraApi.SetFiducialMarkerDetection(
              psrIdentifier,
              psrCameraId,
              !psrCameraState.isDetectingFiducialMarker
            )
          }
          withLetter={false}
        />
      </div>
      <div className="live-image-pref-row">
        <span>Enable Barcode Detection:</span>
        <SwitchButton
          isOn={psrCameraState.isDetectingBarcode}
          onToggle={() =>
            PsrCameraApi.SetBarcodeDetection(
              psrIdentifier,
              psrCameraId,
              !psrCameraState.isDetectingBarcode
            )
          }
          withLetter={false}
        />
      </div>
    </div>
  );
}
